export default __webpack_public_path__ + "static/media/About3.cef592ec.jpeg";